import { useNavigate, useLocation } from 'react-router-dom';

export const useRemoveUrlParam = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const removeParam = (paramName) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete(paramName);

    const newSearch = searchParams.toString();
    const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ''}`;

    navigate(newUrl, { replace: true });
  };

  return { removeParam };
};
